
import React from 'react';
import { UseFormReturn } from 'react-hook-form';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { Form } from '@/components/ui/form';
import BillingInfoForm from '@/components/business/reseller/BillingInfoForm';
import { OrderFormValues } from '@/components/business/reseller/orderFormSchema';

interface OrderFormContainerProps {
  form: UseFormReturn<OrderFormValues>;
  isLoading: boolean;
  onSubmit: (data: OrderFormValues) => Promise<void>;
  selectedCountry: string;
}

const OrderFormContainer: React.FC<OrderFormContainerProps> = ({
  form,
  isLoading,
  onSubmit,
  selectedCountry,
}) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Billing Information</CardTitle>
        <CardDescription>
          Please enter your billing information to complete your purchase
        </CardDescription>
      </CardHeader>
      <CardContent>
        <Form {...form}>
          <form onSubmit={form.handleSubmit(onSubmit)}>
            <BillingInfoForm 
              form={form} 
              isLoading={isLoading} 
              selectedCountry={selectedCountry} 
              requireSubdomain={true}
            />
          </form>
        </Form>
      </CardContent>
    </Card>
  );
};

export default OrderFormContainer;
